// auth
import {auth} from '@drivesally/sally-fn';
const {token: authToken} = auth;

const getAuthToken = (appName) => authToken.getTokens()?.[appName] || null;

export default getAuthToken;
